module.exports = __webpack_public_path__ + "img/img1.70b064ef.png";